import React from 'react';
import '../template-file-css/document-file-template.css';



export const LHH_AbuseAndNeglect = ({
    itemsRef,
    showErrorFor,

}) => {

    return (
        <form id='LHH_AbuseAndNeglect' className='file-pdf-document'>
            <div className='file-template'>

                <p className='w-750'>
                    <h3>Staff Verification of Training on Suspected Abuse or Neglect Reporting Requirements</h3>
                </p>
                <p className='w-750'><hr /></p>
                <p className='w-750'>
                    I acknowledge that I have been informed of and trained on the procedures for reporting suspicions
                    of abuse or neglect in accordance with state reporting laws to include but not limited to the
                    Vulnerable Persons Act and Child Abuse or Neglect Reporting requirements.
                </p>
                <p className='w-750'><hr /></p>
                <p className='w-750'>
                    I understand that I have a personal responsibility to report suspicions of
                    abuse or neglect in accordance with state reporting laws.
                </p>
                <table>
                    <tr>
                        <td className='signature w-300'>&nbsp;</td>
                        <td className='signature w-300'>&nbsp;</td>
                        <td className='signature w-150'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='small w-300'>Staff Signature/ Position or Credentials</td>
                        <td className='small w-300'>Witness/ Position or Credentials</td>
                        <td className='small w-150'>Date</td>
                    </tr>
                </table>


            </div>
        </form >

    )
}











